import { ActionIcon, Breadcrumbs, UnstyledButton } from '@any-ui-react/core';
import classNames from 'classnames';

import { ChevronLeftIcon, ChevronRightIcon } from '@anyx/shared-icons';


export interface HeaderProps {
  /** root of the class name */
  className?: string;
  /** multi level navigation */
  breadcrumbs?: {
    label: React.ReactNode;
    onClick?: () => void;
  }[];
  /** aside node place next to breadcrumbs, useful for status */
  breadcrumbAside?: React.ReactNode;
  /** hide back button */
  hideBackBtn?: boolean;
  /** handle back action */
  onBack?: () => void;
}

export const Header = ({
  className,
  breadcrumbs,
  breadcrumbAside,
  hideBackBtn = false,
  onBack,
}: HeaderProps) => {
  return (
    <div className={classNames('flex items-center gap-x-4', className)}>
      {!hideBackBtn && (
        <ActionIcon variant="default" onClick={onBack}>
          <ChevronLeftIcon className="h-4 w-4 stroke-2" />
        </ActionIcon>
      )}
      <div className="title-secondary flex grow items-center gap-x-2">
        <Breadcrumbs separator={<ChevronRightIcon className="h-4 w-4" />}>
          {breadcrumbs?.map(({ onClick, label }, idx) => (
            <UnstyledButton
              className="text-gray-7 last:text-gray-9 text-lg font-semibold hover:underline"
              key={idx}
              onClick={onClick}
            >
              {label}
            </UnstyledButton>
          ))}
        </Breadcrumbs>
        {breadcrumbAside}
      </div>
    </div>
  );
};
